/**
 * 订单相关接口
 */
import request from './request'

/**
 * 获取订单列表
 * @param {object} params - { pageNum, pageSize }
 */
export function getOrderList(params) {
  return request.post('/api/order/list', params)
}

/**
 * 获取发票申请详情
 * @param {object} params - { id }
 */
export function getInvoiceApplyDetail(params) {
  return request.post('/api/order/getInvoiceApplyDetail', params)
}

/**
 * 申请发票
 * @param {object} params - 发票申请参数
 */
export function applyInvoice(params) {
  return request.post('/api/order/applyInvoice', params)
}

/**
 * 修改发票信息
 * @param {object} params - 发票修改参数
 */
export function updateInvoice(params) {
  return request.post('/api/order/updateInvoice', params)
}

/**
 * 取消发票申请
 * @param {object} params - { id }
 */
export function cancelInvoiceApply(params) {
  return request.post('/api/order/cancelInvoiceApply', params)
}

/**
 * 创建订单
 * @param {object} params - { emagazineCode, periodType, mediaType, quantity }
 */
export function createOrder(params) {
  return request.post('/api/order/createOrder', params)
}

/**
 * 订单支付
 * @param {object} params - { orderNo }
 */
export function payOrder(params) {
  return request.post('/api/order/pay', params)
}

/**
 * 获取微信统一下单参数
 * @param {object} params - { orderNo, type }
 */
export function wxUnifiedOrder(params) {
  return request.post('/api/order/wxUnifiedOrder', params)
}

/**
 * 查询支付状态
 * @param {object} params - { orderNo }
 */
export function getPayStatus(params) {
  return request.post('/api/order/getPayStatus', params)
}
